import React, { useEffect } from "react";
import jsPDF from "jspdf";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAcademicEventTypes,
  fetchAcademicCalendarEvents,
} from "../store/academicCalendarFormSlice.js";
export const useAcademicCalendarPDF = () => {
  /*   const dispatch = useDispatch();
  const { allEventTypes, events } = useSelector(
    (state) => state.academicCalendar
  ); */

  // Initialize data fetching
  /*   useEffect(() => {
    dispatch(fetchAcademicEventTypes());
    dispatch(fetchAcademicCalendarEvents());
  }, [dispatch]); */
  /*  const colorOptions = [
    "#00FF00",
    "#FFFF00",
    "#FFA500",
    "#800081",
    "#FF0000",
    "#DC143C",
    "#FF4500",
    "#4682B4",
    "#6A5ACD",
    "#ADFF2F",
    "#98FB98",
    "#FFD700",
    "#DAA520",
  ]; */
  const colorMap = {
    "Semester Start": "#00FF00",
    "Midterm Exams": "#FFFF00",
    "Final Exams": "#FFA500",
    Registration: "#800081",
    "Add/Drop Deadline": "#FF0000",
    "Thesis Deadline": "#DC143C",
    "Thanksgiving Break": "#FF4500",
    "Winter Break": "#4682B4",
    "Spring Break": "#6A5ACD",
    "Summer Break": "#ADFF2F",
    "Labor Day": "#98FB98",
    "Faculty Meetings": "#FFD700",
    "Grade Submission": "#DAA520",
    "Orientation Week": "#DAA520",
    Commencement: "#DAA520",
  };
  const downloadPDF = (
    filteredEvents,
    academicYear,
    setNotification,
    eventTypes
  ) => {
    console.log("Received events in downloadPDF:", filteredEvents);
    console.log("Received eventTypes in downloadPDF:", eventTypes);
    console.log("Academic Year in downloadPDF:", academicYear);

    // Validate and normalize events array
    const validatedEvents = (
      Array.isArray(filteredEvents) ? filteredEvents : []
    )
      .map((event) => {
        if (!event?.eventStartDate || !event?.eventTypeID) {
          console.warn(
            "Skipping invalid event due to missing startDate or eventTypeId:",
            event
          );
          return null;
        }
        const normalizedStart = normalizeDate(event.eventStartDate);
        if (!normalizedStart) {
          console.warn(
            `Invalid startDate for event ${event.eventTypeName}: ${event.eventStartDate}`
          );
          return null;
        }
        const normalizedEnd = event.eventEndDate
          ? normalizeDate(event.eventEndDate)
          : normalizedStart;
        if (event.eventEndDate && !normalizedEnd) {
          console.warn(
            `Invalid endDate for event ${event.eventTypeName}: ${event.eventEndDate}`
          );
          return null;
        }
        return {
          ...event,
          eventStartDate: normalizedStart,
          eventEndDate: normalizedEnd,
        };
      })
      .filter((event) => event !== null);
    console.log("Validated events after normalization:", validatedEvents);

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const margin = 10;
    const pageWidth = 297 - 2 * margin;
    const pageHeight = 210 - 2 * margin;

    // Title
    const titleText = `Academic Calendar ${academicYear || "School"}`;
    doc.setFontSize(16).setFont("helvetica", "bold");
    doc.text(titleText, margin + pageWidth / 2, margin + 6, {
      align: "center",
    });

    // Calendar
    const calendarAreaWidth = pageWidth * 0.75;
    const calendarHeight = pageHeight * 0.65;

    const startYear = academicYear
      ? parseInt(academicYear.split("/")[0])
      : new Date().getFullYear();
    const startDate = new Date(`${startYear}-08-01`);
    const endDate = new Date(`${startYear + 1}-07-31`);

    const months = [];
    let tempDate = new Date(startDate);
    while (tempDate <= endDate) {
      months.push(new Date(tempDate));
      tempDate.setMonth(tempDate.getMonth() + 1);
    }

    const cols = 4;
    const rows = 3;
    const calWidth = calendarAreaWidth / cols - 2;
    const calHeight = calendarHeight / rows - 2;
    const calendarTop = margin + 10;

    months.forEach((month, index) => {
      if (index >= cols * rows) return;
      const col = index % cols;
      const row = Math.floor(index / cols);
      const x = margin + col * (calWidth + 2);
      const y = calendarTop + row * (calHeight + 2);

      const year = month.getFullYear();
      const monthIndex = month.getMonth();
      const monthName = month.toLocaleString("default", { month: "long" });
      doc.setFontSize(8).setFont("helvetica", "bold");
      doc.text(`${monthName} ${year}`, x + calWidth / 2, y + 4, {
        align: "center",
      });

      const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
      const firstDay = new Date(year, monthIndex, 1).getDay();
      const dayWidth = calWidth / 7;
      const dayHeight = (calHeight - 8) / 6;

      doc.setFontSize(6).setFont("helvetica", "normal");
      ["S", "M", "T", "W", "T", "F", "S"].forEach((d, i) => {
        doc.text(d, x + i * dayWidth + dayWidth / 2, y + 8, {
          align: "center",
        });
      });

      for (let week = 0; week < 6; week++) {
        for (let day = 0; day < 7; day++) {
          const dayNum = week * 7 + day - firstDay + 1;
          const cellX = x + day * dayWidth;
          const cellY = y + 10 + week * dayHeight;

          if (dayNum > 0 && dayNum <= daysInMonth) {
            // Create the current date as YYYY-MM-DD to avoid timezone issues
            const currentDateStr = `${year}-${String(monthIndex + 1).padStart(
              2,
              "0"
            )}-${String(dayNum).padStart(2, "0")}`;
            //console.log(`Processing day: ${currentDateStr}`);

            const matchingEvents = validatedEvents.filter((event) => {
              const startStr = event.eventStartDate; // Already in YYYY-MM-DD
              const endStr = event.eventEndDate || event.eventStartDate; // Already in YYYY-MM-DD
              return currentDateStr >= startStr && currentDateStr <= endStr;
            });

            if (matchingEvents.length > 0) {
              console.log(
                `Found ${matchingEvents.length} events for ${currentDateStr}:`,
                matchingEvents
              );
              const event = matchingEvents[0]; // Prioritize the first event
              const eventName =
                eventTypes?.find((et) => et.eventTypeID === event.eventTypeID)
                  ?.eventName || event.eventTypeName;
              const color = colorMap[eventName] || "#000000";

              console.log(
                `Highlighting ${currentDateStr} with color ${color} for event: ${event.eventTypeName} (${eventName})`
              );
              doc.setFillColor(color);
              doc.rect(cellX, cellY, dayWidth, dayHeight, "F");

              const isLight = [
                "#FFFF00",
                "#00FF00",
                "#98FB98",
                "#ADFF2F",
                "#FFD700",
              ].includes(color);
              doc.setTextColor(isLight ? 0 : 255);
            } else {
              doc.setTextColor(0);
            }

            doc.setDrawColor(200);
            doc.rect(cellX, cellY, dayWidth, dayHeight);
            doc.setFontSize(5);
            doc.text(dayNum.toString(), cellX + dayWidth / 2, cellY + 3, {
              align: "center",
            });

            if (matchingEvents.length > 1) {
              doc.setFillColor(0);
              doc.circle(cellX + dayWidth - 1.5, cellY + 1.5, 0.5, "F");
            }
          }
        }
      }
    });

    // Legend
    const legendX = margin + calendarAreaWidth + 5;
    const legendY = calendarTop;
    doc.setFontSize(8).setFont("helvetica", "bold");
    doc.text("Legend", legendX, legendY);

    const event_Types = Object.keys(colorMap);
    console.log("event_Types ", event_Types);
    const eventTypeNames = event_Types.filter((type) =>
      validatedEvents.some(
        (e) =>
          eventTypes?.find((et) => et.eventTypeID === e.eventTypeID)
            ?.eventName === type
      )
    );
    console.log("Unique event types for legend:", eventTypeNames);
    let offsetY = legendY + 6;
    eventTypeNames.forEach((type) => {
      if (offsetY > calendarTop + calendarHeight - 5) return;
      const color = colorMap[type] || "#000000";
      // Reset font for each item
      doc.setFont("helvetica", "normal");
      doc.setFontSize(6);
      doc.setTextColor(0); // Force black text

      // Draw color indicator
      doc.setFillColor(color);
      doc.rect(legendX, offsetY - 1.5, 3, 3, "F"); // Slightly larger box

      // Draw text
      doc.text(type, legendX + 5, offsetY + 1); // Adjusted position

      offsetY += 5; // Increased spacing between items
    });

    // Key Dates & Public Holidays
    const bottomY = calendarTop + calendarHeight + 5;
    doc.setFontSize(9).setFont("helvetica", "bold");
    doc.text("Key Dates", margin, bottomY);
    doc.text("Public Holidays", margin + pageWidth / 2, bottomY);

    const keyDates = validatedEvents
      .filter((e) => {
        const eventName =
          eventTypes?.find((et) => et.eventTypeID === e.eventTypeID)
            ?.eventName || e.eventTypeName;
        return eventName !== "Public Events";
      })
      .sort((a, b) => new Date(a.eventStartDate) - new Date(b.eventStartDate));
    const holidays = validatedEvents
      .filter((e) => {
        const eventName =
          eventTypes?.find((et) => et.eventTypeID === e.eventTypeID)
            ?.eventName || e.eventTypeName;
        return eventName === "Public Events";
      })
      .sort((a, b) => new Date(a.eventStartDate) - new Date(b.eventStartDate));

    doc.setFontSize(6).setFont("helvetica", "normal");
    let yKey = bottomY + 4;
    keyDates.slice(0, 10).forEach((e) => {
      if (yKey > pageHeight + margin - 5) return;
      const eventName =
        eventTypes?.find((et) => et.eventTypeID === e.eventTypeID)?.eventName ||
        e.eventTypeID;
      const start = new Date(e.eventStartDate).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
      const end =
        e.eventEndDate && e.eventEndDate !== e.eventStartDate
          ? new Date(e.eventEndDate).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
            })
          : "";
      const dateText = end ? `${start} - ${end}` : start;
      doc.text(`${dateText}: ${e.title} (${eventName})`, margin, yKey);
      yKey += 3.5;
    });

    let yHol = bottomY + 4;
    holidays.slice(0, 10).forEach((e) => {
      if (yHol > pageHeight + margin - 5) return;
      const start = new Date(e.eventStartDate).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
      const end =
        e.eventEndDate && e.eventEndDate !== e.eventStartDate
          ? new Date(e.eventEndDate).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
            })
          : "";
      const dateText = end ? `${start} - ${end}` : start;
      doc.text(`${dateText}: ${e.title}`, margin + pageWidth / 2, yHol);
      yHol += 3.5;
    });

    // Footer
    doc.setFontSize(6).setTextColor(100);
    const now = new Date().toLocaleString("en-US", {
      timeZone: "Africa/Nairobi",
    });
    doc.text(`Generated on: ${now}`, margin, pageHeight + margin - 2);

    doc.save(
      `Academic-Calendar-${academicYear.replace("/", "-") || "School"}.pdf`
    );
    setNotification("PDF calendar downloaded successfully!");
  };
  return { downloadPDF };
};

// Helper function to normalize dates to YYYY-MM-DD
const normalizeDate = (dateStr) => {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) {
    console.warn(`Failed to parse date: ${dateStr}`);
    return null;
  }
  return date.toISOString().split("T")[0];
};
